import { Typography } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { isEmpty } from 'lodash';
import { useGetApplication } from '~/controllers/wizard';
import { getStagePayload } from '~/utils/getStagePayload';
import { KsaShareholders } from '~/types/ksa/KsaShareholders';
import ShareholdersSoleProprietor from './components/ShareholdersSoleProprietor';
import ShareholdersMultiple from './components/ShareholdersMultiple';

const Shareholders: FC = () => {
  const applicationQuery = useGetApplication();
  const stagePayload = getStagePayload.wizard(applicationQuery.data);
  const application = useGetApplication();
  const payload = application.data?.payload;

  const activeStep = stagePayload?.activeStep;
  const individualShareholdersCount = payload?.shareholders?.individuals?.length;
  const legalEntities = (payload?.shareholders as KsaShareholders)?.legalEntities;

  return (
    <Container>
      <Typography.Title>{activeStep?.stepName}</Typography.Title>
      {individualShareholdersCount === 1 && isEmpty(legalEntities) ? (
        <ShareholdersSoleProprietor />
      ) : (
        <ShareholdersMultiple />
      )}
    </Container>
  );
};

const Container = styled.div``;

export default Shareholders;
